import React from 'react';

export default function StatusBadge({ status }) {
    if (status===null) {
        return (
            <span className="badge badge-default">Desconhecido</span>
        );
    }
    if (status) {
        return (
            <span className="badge badge-success">Ativado</span>
        );
    }

    return (
        <span className="badge badge-warning">Desativado</span>
    );
}


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/StatusBadge.js